<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 16.5H4a1 1 0 000 2h1v8.65A1 1 0 005.5 29h21a1 1 0 00.5-1.85V18.5h1a1 1 0 000-2zm-4.62 2V27h-1.63v-8.5zm-2.63 0V27h-1.63v-8.5zm-2.63 0V27H16.5v-8.5zm-2.62 0V27h-1.62v-8.5zm-2.62 0V27h-1.63v-8.5zm-2.63 0V27H8.62v-8.5zm-2.63 0V27H6v-8.5zM26 27h-1.62v-8.5H26zM9 9.5h6.5v6h1v-6H23v6h2V5a2 2 0 00-2-2H9a2 2 0 00-2 2v10.5h2zM16.5 5H23v3.5h-6.5zM9 5h6.5v3.5H9z"/><path d="M18.54 14.5a.5.5 0 000 1h2a.5.5 0 000-1z"/></svg>